/*
 * @Author: your name
 * @Date: 2020-11-23 10:05:08
 * @LastEditTime: 2026-06-27 17:34:05
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from "./i18n";
import pstore from './store/pstore.js';
import '@/assets/style/css-variables.css';
import '@/assets/style/reset.css';
import '@/assets/style/global.css';
import "@/assets/scripts/rMessage.js";
import "@/assets/scripts/global.js";
import '@/assets/scripts/registerServiceWorker';
import 'font-awesome/css/font-awesome.min.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/element-variables.scss';

import UUID from "vue-uuid";
import ElementUI from 'element-ui';
import http from './http'
import flvjs from 'flv.js';

Vue.use(ElementUI);
Vue.use(UUID);

//import AMapLoader from '@amap/amap-jsapi-loader';
//Vue.use(AMapLoader);
import favicon from './utils/favicon.js'
favicon();
import Amap from './utils/amap.js'
Vue.use(Amap);
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);
import VueDraggableResizable from "vue-draggable-resizable-gorkys";
import "vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css";
Vue.component('vue-drag-resize', VueDraggableResizable);
import x2js from 'x2js' //xml数据处理插件
Vue.prototype.$x2js = new x2js(); //创建x2js对象，挂到vue原型上

//注册滚动条加载触发事件v-loadmore绑定
import * as directives from '@/assets/scripts/directives.js';
Vue.use(directives);
import animated from 'animate.css';
Vue.use(animated);

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

//屏幕组件
import KDraggableVue from 'k-draggable-vue';
import 'k-draggable-vue/k-draggable-vue.css';
Vue.component('k-draggable-vue', KDraggableVue);
// import VueAMap from 'vue-amap';
// VueAMap.initAMapApiLoader({
//   // 默认高德 sdk 版本为 1.4.4
//   key: 'aebf04dcab79819e1aa194d55831bd66',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder'],
//   v: '1.4.4'
// });
// Vue.prototype.$vueAMap = VueAMap;
// Vue.use(VueAMap);
if (process.env.VUE_APP_COLOR1) {
  document.documentElement.style.setProperty('--theme-color-customized-1', `#${process.env.VUE_APP_COLOR1}`);
}
if (process.env.VUE_APP_COLOR2) {
  document.documentElement.style.setProperty('--theme-color-customized-2', `#${process.env.VUE_APP_COLOR2}`);
}

Vue.use(flvjs);
Vue.prototype.$flvjs = flvjs;

Vue.prototype.$http = http;

Vue.config.productionTip = false

Vue.prototype.$store = store;
//
Vue.prototype.$pstore = pstore;

Vue.prototype.$_i18n = i18n;

Vue.prototype.$bus = new Vue();

new Vue({
  i18n,
  router,
  store,
  pstore,
  Amap,
  //VueAMap,
  render: h => h(App)
}).$mount('#app')
